import { ChevronDown } from "components/icons/generated";
import BadgeNext from "ds/components/BadgeNext";
import { BadgeVariants } from "ds/components/BadgeNext/types";
import { BlueprintState } from "types/generated";

type RunHistoryEntryConfig = {
  variant: BadgeVariants;
  text: string;
};

/** @public (Knip ignored - used in the file and exported for stories) */
export const BLUEPRINT_STATES: Record<BlueprintState, RunHistoryEntryConfig> = {
  [BlueprintState.Deleted]: { variant: "red", text: "Deleted" },
  [BlueprintState.Draft]: { variant: "gray", text: "Draft" },
  [BlueprintState.Published]: { variant: "blue", text: "Published" },
  [BlueprintState.Unknown]: { variant: "white", text: "Unknown" },
};

type BlueprintStateBadgeProps = {
  state: BlueprintState;
  className?: string;
  withDropdown?: boolean;
};

const BlueprintStateBadge = ({ state, className, withDropdown }: BlueprintStateBadgeProps) => {
  if (!BLUEPRINT_STATES[state]) {
    return null;
  }

  return (
    <BadgeNext
      variant={BLUEPRINT_STATES[state].variant}
      type="strong"
      className={className}
      text={BLUEPRINT_STATES[state].text}
      endIcon={withDropdown ? ChevronDown : undefined}
    />
  );
};

export default BlueprintStateBadge;
